import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import SectionTitle from './SectionTitle';

interface IProps {
  title: string;
  choices: (ReactNode | ReactElement)[];
  showBtnExpand: boolean;
  isOpen: boolean;
  onToggleOpen: (isOpen: boolean) => void;
}

export default function FilterSectionChoice({
  title,
  choices,
  showBtnExpand,
  isOpen,
  onToggleOpen,
}: IProps) {
  const { t } = useTranslation();

  return (
    <div className="py-2 border-b">
      <SectionTitle title={title} />
      <div className="grid gap-y-1">{choices}</div>
      {showBtnExpand && (
        <button
          type="button"
          className="text-gray-500 mt-2 underline"
          onClick={() => onToggleOpen(!isOpen)}>
          {t(isOpen ? 'Less' : 'More')}
        </button>
      )}
    </div>
  );
}
